import { render } from "./BaseSelect.vue?vue&type=template&id=7a0dc6b2"
import script from "./BaseSelect.vue?vue&type=script&lang=js"
export * from "./BaseSelect.vue?vue&type=script&lang=js"
script.render = render

export default script